import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { useSeo } from '../utils/seo';
import { FinanciarUsadoForm } from '../components/forms/FinanciarUsadoForm';
import { ButtonAnchor } from '../components/ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
const puntos = ['Financiación sobre usados seleccionados del catálogo', 'Tomamos tu usado actual como anticipo', 'Planes en 12, 24, 36 y 48 cuotas', 'Evaluación rápida y sin compromiso'];
export function FinanciarUsado() {
  const [params] = useSearchParams();
  useSeo('Financiá tu próximo usado | VCARS', 'Financiación para usados seleccionados de VCARS: anticipo, permuta y planes de cuotas con asesoramiento personalizado.');
  return <main className="bg-ink" data-id="element-469" data-mp="36zjtqgw254mu">
      <div className="border-b border-line bg-surface" data-id="element-470" data-mp="36za4iviu71i7">
        <div className="mx-auto grid w-full max-w-7xl gap-10 px-5 py-14 md:grid-cols-[1.1fr_1fr] md:px-8 md:py-20" data-id="element-471" data-mp="3bzy3q4h7yoni">
          <div data-id="element-472" data-mp="1dv2k6exy6gvk">
            <h1 className="text-4xl font-black leading-[1.05] tracking-tight text-white md:text-[52px]" data-id="element-473" data-mp="1dujebwlknixw">
              Financiá tu próximo usado
            </h1>
            <p className="mt-5 text-lg font-semibold text-white/90" data-id="element-474" data-mp="1nsqsk7oh7mw7">
              Llevate la unidad que elegiste del catálogo VCARS.
            </p>
            <p className="mt-3 max-w-xl text-base leading-relaxed text-mist" data-id="element-475" data-mp="1ivgwi96l0cze">
              Trabajamos alternativas de financiación específicas para usados
              seleccionados: evaluamos tu anticipo, tu permuta y tu perfil para armar el
              plan de cuotas que mejor se adapte a vos.
            </p>

            <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-476" data-mp="21jvkenllravz">
              {puntos.map(p => <li key={p} className="flex items-start gap-2.5" data-id="element-477" data-mp="2fjmuid90074p">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-neon/15 text-neon" data-id="element-478" data-mp="2fjwla31vaibg">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-479" data-mp="2bg8cjh1i1gom" />
                  </span>
                  <span className="text-[14.5px] font-medium text-white" data-id="element-480" data-mp="2ijeuy5snrwwz">{p}</span>
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-481" data-mp="2siw3cuzaoown">
              <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" data-id="element-482" data-mp="2shuqckypxsca">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-483" data-mp="31c94gk7iiwtt" />
                Hablar con un vendedor
              </ButtonAnchor>
            </div>
          </div>

          <div data-id="element-484" data-mp="3b9x6lv7g76m0">
            <FinanciarUsadoForm vehiculoInicial={params.get('vehiculo') ?? ''} data-id="element-485" data-mp="3b9drem96mwbo" />
          </div>
        </div>
      </div>
    </main>;
}